import { vipStore } from './vip.store';
import { summerStore } from './summer.store';
import { spinWheelStore } from './spin-wheel.store';
import { halloweenStore } from './halloween.store';
import { userStore } from './user.store';
import { xmasStore } from './xmas.store';

export const GlobalStore = {
  SPIN_WHEEL_STORE: spinWheelStore,
  VIP_STORE: vipStore,
  SUMMER_STORE: summerStore,
  HALLOWEEN_STORE: halloweenStore,
  USER_STORE: userStore,
  XMAS_STORE: xmasStore,
};

export enum GlobalStoreName {
  SPIN_WHEEL_STORE = 'SPIN_WHEEL_STORE',
  VIP_STORE = 'VIP_STORE',
  SUMMER_STORE = 'SUMMER_STORE',
  HALLOWEEN_STORE = 'HALLOWEEN_STORE',
  USER_STORE = 'USER_STORE',
  XMAS_STORE = 'XMAS_STORE'
}
